import { DataBaseComponent } from "./data-base-component";
import { convertArray, isNumber } from "@bonusmap/shared_ui/library";
/**
 * Questo componente gestisce il campo organizations
 *  organizations: z.array(z.number()).optional().nullable(),
 *  //organizations è un'array di organization_id 
    // perché ogni organizzazione che edita il profilo viene registrata
    // in modo da poter tenere traccia di chi ha modificato il profilo  
    // ma il profilo resta unico
    Non ha bisogno di UI, è un campo nascosto che viene gestito dal sistema
 */
export class DataOrganizationsComponent extends DataBaseComponent {
    static webComponentName: string = "data-organizations";
    get value(): number[] {
        let v = super.value;
        if (!Array.isArray(v)) {
            v = [];
        }
        v = convertArray(v,"number");
        const loggedOrganizationId = this.loggedOrganizationId;
        if (isNumber(loggedOrganizationId) && loggedOrganizationId >= 0) {
            if (!v.includes(loggedOrganizationId)) {
                v.push(loggedOrganizationId);
            }
        }
        return v;
    }
    set value(val: any) {
        super.value = val;
    }

    constructor() {
        super();
    }

    protected render(): void {
        return ;
// this.innerHTML = `<pre>${JSON.stringify(this.value,null,2) }</pre>`;
    }
    addDataForTemplate(): Record<string, any> {
        return {
            
        };
    }
}
